/* White Cove — gentle motion layer (Autumn 2026)
   1. Reveal each homepage/section as it enters the viewport.
   2. Soft parallax for decorative elements marked data-wc-parallax.
   Respects prefers-reduced-motion and the Shopify theme editor. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  function markSections() {
    var sections = document.querySelectorAll('main .shopify-section');
    for (var i = 0; i < sections.length; i++) {
      var s = sections[i];
      if (i === 0 || s.querySelector('.wc-hero')) continue;
      s.classList.add('wc-reveal');
    }
  }

  function revealAll(targets) {
    for (var i = 0; i < targets.length; i++) targets[i].classList.add('is-inview');
  }

  function setupReveal() {
    markSections();
    var targets = document.querySelectorAll('.wc-reveal');
    if (reduce || designMode || !('IntersectionObserver' in window)) {
      revealAll(targets);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-inview');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
    for (var i = 0; i < targets.length; i++) io.observe(targets[i]);
    // Anything already in view on load should not wait.
    setTimeout(function () {
      for (var j = 0; j < targets.length; j++) {
        var r = targets[j].getBoundingClientRect();
        if (r.top < window.innerHeight * 0.9) targets[j].classList.add('is-inview');
      }
    }, 120);
  }

  function setupParallax() {
    var els = document.querySelectorAll('[data-wc-parallax]');
    if (reduce || !els.length) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        var r = el.getBoundingClientRect();
        var mid = r.top + r.height / 2 - vh / 2;
        var f = parseFloat(el.getAttribute('data-wc-parallax')) || 0.1;
        el.style.transform = 'translate3d(0,' + (-mid * f).toFixed(1) + 'px,0)';
      }
      ticking = false;
    }
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  function init() {
    setupReveal();
    setupParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: newly loaded sections should be visible immediately.
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target;
    if (s && s.classList) s.classList.add('is-inview');
  });
})();
